<template>

<q-item v-if="isMaster" :class="pp.isInMaintenanceMode ? 'bg-orange' : 'bg-green'">

    <q-item-section avatar>
        <q-icon :name="pp.isInMaintenanceMode ? 'warning' : 'done'" size="sm" color="white" />
    </q-item-section>

    <q-item-section>
        <q-item-label class="text-white" overline>
            <b v-if="pp.isInMaintenanceMode">MAINTENANCE ACTIVÉE</b>
            <b v-else>APPLICATION EN LIGNE</b>
        </q-item-label>
    </q-item-section>

    <q-item-section side>
        <q-btn-dropdown :color="!utils.queue_failed_count ? 'white':'red-8'" :dropdown-icon="!utils.queue_failed_count ? 'settings' : 'error_outline'"
                        dense outline>
            <q-list separator>

                <q-item clickable v-close-popup @click="toggleMaintenanceMode()" :class="!pp.isInMaintenanceMode ? 'bg-red-4':'bg-green-4'">
                    <q-item-section class="text-bold">
                        <q-item-label v-if="pp.isInMaintenanceMode">Remettre en ligne l'application</q-item-label>
                        <q-item-label v-else>Passer en mode Maintenance</q-item-label>
                    </q-item-section>
                    <q-item-section side><q-icon :name="pp.isInMaintenanceMode ? 'lock_open' : 'lock'" :color="pp.isInMaintenanceMode ? 'green' :'orange'" /></q-item-section>
                </q-item>

                <!-- <q-item clickable v-close-popup @click="renameFilesAfterPush()">
                    <q-item-section><q-item-label>Renommer Fichiers après PUSH</q-item-label></q-item-section>
                    <q-item-section side><q-icon name="edit" color="info" /></q-item-section>
                </q-item> -->

                <!-- <q-item v-if=" ! isProd" clickable v-close-popup @click="renameFilesAfterPush()">
                    <q-item-section>
                        <q-item-label>Renommer les Fichiers après PUSH...</q-item-label>
                        <q-item-label>[SSH] Commande pour renommer les Fichiers/Dossier après PUSH</q-item-label>
                        <q-item-label caption>bash $HOME/projects/aghtaxi_appli/rename-files-after-push.sh</q-item-label>
                    </q-item-section>
                    <q-item-section side>
                        <q-btn icon="content_copy" @click.stop="copyToClipboard('bash $HOME/projects/aghtaxi_appli/rename-files-after-push.sh','Command Rename Files')" color="grey" outline dense />
                        </q-item-section>
                </q-item> -->

                <!-- <q-item clickable v-close-popup @click="open('https://app.declicc.fr/pma-agh-WICOD/index.php?pma_username=wicod')">
                    <q-item-section><q-item-label>PhpMyAdmin</q-item-label></q-item-section>
                    <q-item-section side><q-icon name="open_in_new" color="grey" /></q-item-section>
                </q-item> -->

                <!-- <q-item dense class="bg-grey-4">&nbsp;</q-item> -->

                <q-item clickable v-close-popup @click="routeCache()">
                    <q-item-section><q-item-label>Route:cache</q-item-label></q-item-section>
                    <q-item-section side><q-icon name="arrow_forward" color="grey" /></q-item-section>
                </q-item>

                <q-item clickable v-close-popup @click="configCache()">
                    <q-item-section><q-item-label>Config:cache</q-item-label></q-item-section>
                    <q-item-section side><q-icon name="arrow_forward" color="grey" /></q-item-section>
                </q-item>

                <!-- <q-item dense class="bg-" v-if="utils.queue_failed_count">&nbsp;</q-item> -->
                <q-separator class="q-my-md" v-if="utils.queue_failed_count" />

                <q-item clickable v-close-popup @click="queueFailed()" class="bg-orange-3"
                    v-if="utils.queue_failed_count">
                    <q-item-section>
                        <q-item-label>Queue:failed</q-item-label>
                        <q-item-label caption>Liste des Jobs Failed</q-item-label>
                    </q-item-section>
                    <q-item-section side><q-icon name="visibility" color="grey" /></q-item-section>
                </q-item>

                <q-item clickable v-close-popup @click="queueRetryAll()"
                    v-if="utils.queue_failed_count">
                    <q-item-section>
                        <q-item-label>Queue:retry all</q-item-label>
                        <q-item-label caption>Relancer tous les Jobs Failed</q-item-label>
                   </q-item-section>
                    <q-item-section side><q-icon name="refresh" color="grey" /></q-item-section>
                </q-item>

                <q-item clickable v-close-popup @click="queueFlush()"
                    v-if="utils.queue_failed_count">
                    <q-item-section>
                        <q-item-label>Queue:flush</q-item-label>
                        <q-item-label caption>Supprimer tous les Jobs Failed</q-item-label>
                   </q-item-section>
                    <q-item-section side><q-icon name="delete" color="orange-8" /></q-item-section>
                </q-item>

                <!-- <q-item dense>&nbsp;</q-item> -->
                <q-separator class="q-my-md" />

                <q-item v-close-popup @click="getContentLastLog()" clickable>
                    <q-item-section><q-item-label>Voir le dernier Log</q-item-label></q-item-section>
                    <q-item-section side><q-icon name="visibility" color="grey" /></q-item-section>
                </q-item>
                <q-item v-close-popup v-if="utils.countUselessFiles.logs >= 1 || utils.countUselessFiles.temp >= 1" clickable
                        @click="deleteLogsAndTemps()">
                    <q-item-section>
                        <q-item-label lines="2">Supprimer les anciens logs {{ (utils.countUselessFiles.temp >= 1 ? ' et les temporaires' : '') }}</q-item-label>
                        <q-item-label caption>en préservant le dernier log</q-item-label>
                    </q-item-section>
                    <q-item-section side><q-icon name="delete" color="grey" /></q-item-section>
                </q-item>

            </q-list>
        </q-btn-dropdown>
    </q-item-section>
</q-item>

<!-- LOGS Modal -->

<MyDialog maximized v-if="showModalLogs" v-model="showModalLogs" title="Dernier Log"
        @update:modelValue="v => showModalLogs = v">
<!-- word-break: break-all!important; max-width:100%!important; flex-wrap: wrap!important; -->
 <!-- style="width:100%!important;word-break: break-all!important;" -->
    <q-card-actions align="left" class="col-12 q-mt-lg">
        <q-btn label="Fermer" outline color="primary" v-close-popup class="q-mt-md q-ml-md" />
    </q-card-actions>
    <q-separator />

    <q-card-section class="q-pa-sm col-12">
        <div v-dompurify-html="contentLastLog" style="word-break: break-word!important;"></div>
    </q-card-section>

    <q-separator />
    <q-card-actions align="right" class="col-12">
        <q-btn label="Fermer" outline color="primary" v-close-popup class="q-mt-md q-mr-md" />
    </q-card-actions>
</MyDialog>

</template>

<script>
import { ref } from '@vue/reactivity'
// import { defineAsyncComponent } from '@vue/runtime-core'
import { pp, link, notify, e, dater } from '@helpers'

export default {
    name: 'WebmasterActions',
    // components:{
    //     MyDialog: defineAsyncComponent(() => import('@/components/partials/MyDialog') ),
    // //     myAlert: defineAsyncComponent(()=>import('@/components/partials/MyAlert'))
    // },
    // data:()=>({
    //     showModalLogs: false,
    //     contentLastLog: null,
    // }),
    // methods:{


    setup(props){

// log('in WebmasterActions', )

        let showModalLogs = ref(false)
        let contentLastLog = ref(null)

        return {
            showModalLogs,
            contentLastLog,

            toggleMaintenanceMode:()=>{

                $q.dialog({title: pp().isInMaintenanceMode ? "Mettre en ligne l'application" : "Passer l'application en mode Maintenance",ok:{label:'Continuer', color:'orange', outline: true},cancel:true})
                    .onOk(()=>{

                        axios.get(route(`app-in-${pp().isInMaintenanceMode ? 'live':'maintenance'}`))
                            .then(()=>{
                                link(route(route().current(), pp().item?.id || route().params))
                            })
                    })
            },

            renameFilesAfterPush:()=>{

                if( ! pp().isInMaintenanceMode){
                    return notify('warning', 'Passer l\'Application en Mode Maintenance avant...')
                }

                $q.dialog({title: "Renommer les Fichiers/Dossier après avoir Pushé",ok: {label:'Renommer', color:'orange'},cancel:true,html:true,
                                message:    `<h6>Attention, Renommages automatique !</h6>
                                            <p>Le dossier js/NEW_vuejs -> js/vuejs (si il faut)</p>
                                            <p>Le fichier NEW_mix-manifest.json -> mix-manifest.json (si il faut)</p>
                                            <p>Le fichier js/NEW_appversion.json -> js/appversion.json (si il faut)</p>
                                            <p><small>Appelle le script placé à la racine: 'rename-files-after-push.sh'</small></p>`})
                    .onOk(()=>{

                        axios.get(route('rename-files-after-push'))
                            .then((res)=>{
                                // if(res.data.error){
                                //     return notify('info', res.data.error)
                                // }
                                notify('info', res.data.msg,'Recharger la page...')
                            })
                    })
            },


            routeCache:()=>{
                $q.dialog({title: "Mettre en cache les routes ?",ok: true,cancel:true})
                    .onOk(()=>{

                        axios.get(route('app-route-cache'))
                            .then((res)=>{
                                // log(res);
                                notify('info', res.data.msg) })
                            })
            },
            configCache:()=>{
                $q.dialog({title: "Mettre en cache la config ?",ok: true,cancel:true})
                    .onOk(()=>{

                        axios.get(route('app-config-cache'))
                            .then((res)=>{ notify('info', res.data.msg) })
                    })
            },


            queueFailed:()=>{

                axios.get(route('app-queue-failed'))
                    .then((res)=>{
                        // log(res)
                        var msg = !res.data?.length ? '<h2>Nothing !</h2>' : ''

                        _.each(res.data, (d,k)=>{
                            msg += `<p>#${k+1} - ${dater.formatDate(d.failed_at, 'dddd, D MMMM YYYY à HH:mm:ss')}</p>`
                            msg += `<pre>${d.exception}</pre>`
                        })

                        $q.dialog({title: 'Jobs Failed', html: true, maximized: true, ok:{label: 'Fermer'}, cancel:false,
                       //         ok:res.data.length ? {label: 'Vider',color:'red-8',outline:true} : false,
                                message: msg
                        })
                       // .onOk(()=>{
                       //     this.queueFlush() // Vidage Failed Jobs
                       // })
                    })
            },
            queueRetryAll:()=>{
                $q.dialog({title: "Relancer les 'Jobs Failed' ?",ok: true,cancel:true,html:true,
                                message:"<p class='text-orange-8'><b>Il n'y a pas d'Admin de Connecté ???</b></p><p>Car ils peuvent aussi faire l'action...</p>"})
                    .onOk(()=>{

                        axios.get(route('app-queue-retry-all'))
                            // .then((res)=>{ notify('info', res.data.msg) })
                            .then(()=>{ notify('info', 'Jobs Failed relancés') })
                    })
            },
            queueFlush:()=>{
                $q.dialog({title: "Vider les 'Jobs Failed' ?",ok: true,cancel:true})
                    .onOk(()=>{

                        axios.get(route('app-queue-flush'))
                            .then((res)=>{ notify('info', res.data.msg) })
                    })
            },


            // logs & temp files
            getContentLastLog:()=>{

                axios.get(route('open-last-log'))
                    .then((response) => {
                        contentLastLog.value = response.data.data.file;
                        showModalLogs.value = true;
                    })
                    .catch((error) => { e('Error in LogFiles.vue - getContentLastLog', error); });
            },
            deleteLogsAndTemps:()=>{

                axios.get(route('delete-useless-files'))
                    .then(() => {
                        pp().utils.countUselessFiles['logs'] = 1;

                        notify("positive", "Anciens fichiers de logs et fichiers temporaires (/storage/app/) correctement supprimés.");
                    })
                    .catch((error) => { e('Error in LogFiles.vue - deleteLogsAndTemps', error); });
            },
        }
    }
}
</script>
